import { Component, type ReactNode } from 'react';

interface Props {
    children: ReactNode;
    /** Se "page", mostra UI inline che NON occupa l'intero schermo (per nested boundary dentro layout). */
    variant?: 'fullscreen' | 'page';
}
interface State {
    hasError: boolean;
    error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: { componentStack: string | null }) {
        // log in dev e in prod (Sentry hook futuro qui)
        console.error('[ErrorBoundary] Unhandled error', error, info.componentStack);
    }

    private reset = () => this.setState({ hasError: false, error: undefined });

    render() {
        if (this.state.hasError) {
            const variant = this.props.variant ?? 'fullscreen';
            const wrap =
                variant === 'fullscreen'
                    ? 'flex min-h-screen items-center justify-center bg-zinc-950 p-4'
                    : 'flex items-center justify-center p-6';
            return (
                <div className={wrap}>
                    <div className="text-center max-w-sm">
                        <h1 className="text-xl font-bold text-zinc-100">Qualcosa è andato storto</h1>
                        <p className="mt-2 text-sm text-zinc-400">{this.state.error?.message ?? 'Errore imprevisto'}</p>
                        <div className="mt-4 flex gap-2 justify-center">
                            <button
                                onClick={this.reset}
                                className="rounded-lg bg-blue-500 hover:bg-blue-600 px-4 py-2 text-sm font-medium text-white"
                            >
                                Riprova
                            </button>
                            <button
                                onClick={() => window.location.reload()}
                                className="rounded-lg border border-zinc-700 hover:bg-zinc-800 px-4 py-2 text-sm font-medium text-zinc-200"
                            >
                                Ricarica
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
